// extracted by mini-css-extract-plugin
export var deleteIcon = "_p8-5";
export var deleteOption = "_p8-3";
export var divider = "_p8-2";
export var downloadIcon = "_p8-4";
export var drawer = "_p8-0";
export var drawerFooter = "_p8-6";
export var drawerOpen = "_p8-1";
export var highlighted = "_p8-7";
export var lighterHighlight = "_p8-8";